import { render, staticRenderFns } from "./DocumentLists.component.vue?vue&type=template&id=381e74ce&scoped=true&"
import script from "./DocumentLists.component.vue?vue&type=script&lang=js&"
export * from "./DocumentLists.component.vue?vue&type=script&lang=js&"
import style0 from "./DocumentLists.component.vue?vue&type=style&index=0&id=381e74ce&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "381e74ce",
  null
  
)

export default component.exports